import React from 'react'
import './index.css';


function ButtonRed({ text, icon, handleOnClick }) {
    
    return (

        <button className="lover-button-red" onClick={handleOnClick}>
            {icon ? <img src={require(`../../../assets/icons/${icon}`)} /> : ''}
            <p>{text}</p>
        </button>
    )
}

export default ButtonRed;

